import React from 'react'

import { useTranslation } from 'react-i18next'
import TitleComponent from '../../../global/Custom/TitleComponent/TitleComponent'
import ProductUpdateScreen from './ProductUpdateScreen'

function ProductUpdate() {
  const {t} = useTranslation()

  return (
    <div>
        <TitleComponent title={t('Cập nhật sản phẩm')} isExist={false} />
        <ProductUpdateScreen/>
    </div>
  )
}

export default ProductUpdate
